import React from "react";
import { mediaUrl } from "@/lib/api";

// Shows the category's library icon (image) when set, otherwise the legacy emoji.
export function CategoryIcon({ cat, size = 32, className = "" }) {
  if (!cat) return null;
  // Rendered as a background-image span (not <img>) so it keeps its fixed size even inside
  // Editable/layout wrappers that force `[&_img]:!h-full [&_img]:!w-full` on descendant images.
  if (cat.icon_url) return (
    <span
      role="img"
      aria-label={cat.name || "kategori"}
      data-testid={`cat-icon-img-${cat.slug || cat.id}`}
      style={{
        width: size, height: size, flex: "0 0 auto",
        backgroundImage: `url(${mediaUrl(cat.icon_url)})`,
        backgroundSize: "contain", backgroundPosition: "center", backgroundRepeat: "no-repeat",
      }}
      className={`inline-block align-middle ${className}`}
    />
  );
  return <span style={{ fontSize: size * 0.8, lineHeight: 1 }} className={`inline-block ${className}`}>{cat.icon}</span>;
}
